import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { AifcLayoutModule } from '../../../shared-layout/aifc-layout.module';

/**
 * Shell for the root `/` section — header + <router-outlet> + footer, shared
 * by the "Business Services" menu content (BusinessServicesPageComponent,
 * default child) and any other top-level public area routed as its sibling
 * (e.g. /marketplace) so they don't each duplicate their own
 * header/footer/cookie-banner. Standalone, but still imports AifcLayoutModule
 * directly (an NgModule) to use AifcHeaderComponent/AifcFooterComponent/
 * CookieBannerComponent — standalone components can import NgModules that
 * export what they need, no need to convert those too for this to work.
 *
 * A child route can hide the footer with `data: { footerVisible: false }`
 * (same key aifc-portal's CustomLayoutComponent reads) — used by the
 * full-viewport Data Marketplace iframe.
 */
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  imports: [RouterOutlet, AsyncPipe, AifcLayoutModule],
})
export class LandingComponent {
  private readonly router = inject(Router);

  isFooterVisible$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => {
      // берем footerVisible из роута, спускаясь по дереву вниз
      let route = this.router.routerState.root.snapshot;
      let footerVisible: boolean | undefined = undefined;

      while (route.firstChild) {
        route = route.firstChild;
        if (route.data && 'footerVisible' in route.data) {
          footerVisible = route.data['footerVisible'];
        }
      }
      return footerVisible !== false;
    })
  );
}
